module.exports = __webpack_public_path__ + "static/media/newMessage.14b6373d.mp3";